import React from 'react'
import { IonModal, IonImg, IonButtons, IonButton, IonToolbar } from '@ionic/react'
import { TimelineConstants } from '../../features/timeline/store/timeline.constants'
import { useDispatch } from 'react-redux'
import './Modal.component.css'

interface IModalProps {
  showModal: boolean
  imgSource: string
}

const ZModal: React.FC<IModalProps> = (props: IModalProps) => {
  const dispatch = useDispatch()
  const { showModal, imgSource } = props

  const dismiss = () => {
    dispatch({ type: TimelineConstants.RESET_TIMELINE })
  }

  return (
    <IonModal qa-id='main_zmodal' showBackdrop={showModal} isOpen={showModal} onDidDismiss={dismiss} className='zmodal'>
      {imgSource && <IonImg qa-id='item_zmodal_img' src={imgSource} alt='Modal image' />}

      {!imgSource && <img src='http://placekitten.com/400/400' alt='kitten' />}
      <IonToolbar>
        <IonButtons slot='end'>
          <IonButton qa-id='modal_close_button' onClick={dismiss}>
            Close
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonModal>
  )
}

export default ZModal
